export default __webpack_public_path__ + "static/media/jobtrack01.47289744.png";